module.exports = __webpack_public_path__ + "img/ec.af41b5f1.svg";